import * as React from "react";
import styled from "styled-components";
import { graphql } from "gatsby";
import { GatsbyImage, getImage } from "gatsby-plugin-image";
import { useWindowSize } from "hooks";

import {
  Header,
  Layout,
  Seo,
  Livestream,
  Donation,
  Agenda,
  Footer,
  Speakers,
} from "../components";

const IndexPage = ({ data }) => {
  const { windowWidth } = useWindowSize();
  const isMobile = windowWidth < 1150;
  return (
    <Layout>
      <Seo
        pageSpecificTitle="Parkinson's Ireland - Educational Conference 2026"
        pageSpecificDescription="Parkinson's Ireland Educational Conference 2026 streaming live on Saturday, April 25th."
      />
      <Header image={isMobile ? data.mobileHeader : data.header} />
      <Livestream />
      <Donation image={data.donateBanner} />
      <Speakers speakers={data.speakers.frontmatter.speakers} />
      <section style={{ position: "relative", overflow: "hidden" }}>
        <Agenda />
        <ImageContainer>
          <GatsbyImage
            image={getImage(data.footerBanner)}
            alt="Grandfather & Grandaughter"
          />
        </ImageContainer>
        <CutoutContainer>
          <GatsbyImage
            image={getImage(data.cutout)}
            alt="Grandfather & Grandaughter"
          />
        </CutoutContainer>
      </section>
      <Footer />
    </Layout>
  );
};

export const pageQuery = graphql`
  query {
    header: file(relativePath: { eq: "header-background.png" }) {
      id
      childImageSharp {
        gatsbyImageData(placeholder: BLURRED, layout: FULL_WIDTH, quality: 90)
      }
    }
    mobileHeader: file(relativePath: { eq: "header-background-mobile.png" }) {
      id
      childImageSharp {
        gatsbyImageData(placeholder: BLURRED, layout: FULL_WIDTH, quality: 90)
      }
    }
    donateBanner: file(relativePath: { eq: "donate-banner.png" }) {
      id
      childImageSharp {
        gatsbyImageData(placeholder: BLURRED, layout: FULL_WIDTH, quality: 90)
      }
    }
    footerBanner: file(relativePath: { eq: "footer-banner.png" }) {
      id
      childImageSharp {
        gatsbyImageData(placeholder: BLURRED, layout: FULL_WIDTH, quality: 90)
      }
    }
    cutout: file(relativePath: { eq: "cutout.png" }) {
      id
      childImageSharp {
        gatsbyImageData(placeholder: BLURRED, layout: FULL_WIDTH, quality: 90)
      }
    }
    speakers: markdownRemark(frontmatter: { title: { eq: "Speakers" } }) {
      id
      frontmatter {
        title
        speakers {
          id
          description
          image {
            childImageSharp {
              gatsbyImageData(layout: FULL_WIDTH, placeholder: BLURRED)
            }
          }
          name
          title
        }
      }
    }
  }
`;

const ImageContainer = styled.div`
  position: absolute;
  width: 100%;
  height: auto;
  min-height: 120px;
  z-index: -1;
  margin: 0 auto;
  bottom: 0;
  left: 0;
  @media (min-width: 768px) {
    min-height: 340px;
  }
  @media (min-width: 1150px) {
    min-height: 380px;
  }
`;

const CutoutContainer = styled.div`
  position: absolute;
  width: 80%;
  height: auto;
  min-height: 120px;
  z-index: 3;
  bottom: -3%;
  right: 0;
  margin: 0 auto;
  @media (min-width: 768px) {
    min-height: 340px;
  }
  @media (min-width: 1150px) {
    min-height: 685px;
    max-width: 1440px;
    width: 70%;
    bottom: -12%;
  }
  @media (min-width: 1600px) {
    width: 55%;
  }
`;
export default IndexPage;
